import request from '@/utils/request'

const url = '/auth-service/accounts'

export function page(params) {
  return request({
    url: `${url}/page`,
    method: 'get',
    params: params
  })
}

export function view(id) {
  if(!id){
    return false
  }
  return request({
    url: `${url}/${id}`,
    method: 'get',
    params: {}
  })
}

export function create(params) {
  return request({
    url: `${url}`,
    method: 'post',
    params: params
  })
}

export function update(params) {
  return request({
    url: `${url}/${params.id}`,
    method: 'put',
    params: params
  })
}

export function remove(id) {
  return request({
    url: `${url}/${id}`,
    method: 'delete'
  })
}

export function enabled(params) {
  return request({
    url: `${url}/enabled/${params.id}/${params.enabled}`,
    method: 'post'
  })
}

export function newerGift(params) {
  return request({
    url: `${url}/newer_gift`,
    method: 'post'
  })
}

export function giveGift(params) {
  return request({
    url: `${url}/give_gift`,
    method: 'post'
  })
}

export function freeGift(params) {
  return request({
    url: `${url}/free_gift`,
    method: 'post'
  })
}

export function downloadGift(params) {
  return request({
    url: `${url}/download_gift`,
    method: 'post'
  })
}

export function updatePassword(params) {
  return request({
    url: `${url}/${params.id}/update_password`,
    method: 'put',
    params: params
  })
}

export function removeToSetmeal(params) {
  return request({

  })
}

